<div class="c-page image" *ngIf="imageSrc$ | async as imageSrc">
    <img [src]="imageSrc" />
</div>
